import Number from './Number'

// class Punchcard extends Number {
// }

export default Number
